module.exports = __webpack_public_path__ + "images/admin/settings-right-col-bg.png";